const disabledResponse = () =>
  Promise.reject(new Error('当前版本未启用该商业扩展接口'));

class FenghuaiAccountAPI {
  checkout() {
    return disabledResponse();
  }

  subscription() {
    return disabledResponse();
  }

  getLimits() {
    return Promise.resolve({ data: {} });
  }

  toggleDeletion() {
    return disabledResponse();
  }

  createTopupCheckout() {
    return disabledResponse();
  }
}

export default new FenghuaiAccountAPI();
